import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store/store';
import { clearMethodStatus } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';

import { OperationResultModal } from 'components/Profile/Subscription/OperationResultModal';

export const MethodSuccessModal = () => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const dispatch = useAppDispatch();

	return (
		<OperationResultModal
			title={modalTranslate('successMethodModal.title')}
			description={modalTranslate('successMethodModal.description')}
			confirm={modalTranslate('successMethodModal.confirm')}
			type={'success'}
			onClose={() => {
				dispatch(clearMethodStatus());
			}}
		/>
	);
};
